import * as React from 'react';

import MuiStep from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';

// import { Warning } from 'assets/icons';
import Warning from '@material-ui/icons/Error';


const Step = (props) => {
  const { icon, disabled, onClick, title, error, children, ...rest } = props;

  const ariaCurrent = rest.active ? 'step' : undefined;
  return (
    <MuiStep aria-current={ariaCurrent} disabled={disabled} {...rest}>
      {onClick ? (
        <StepButton disabled={disabled} icon={error ? <Warning color="error" /> : icon} onClick={onClick}>
         {title}
        </StepButton>
      ) : (
        <StepLabel disabled={disabled} error={error}>
          {title}
        </StepLabel>
      )}
      {children && <StepContent>{children}</StepContent>}
    </MuiStep>
  );
};
export { Step };
